/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetOrganizationIdentifiers = require('../../common/services/GetOrganizationIdentifiers');
var GetOrganizationLicenseDetails = require('../services/GetOrganizationLicenseDetails');
var SecOrganizationLicenseDashboardView = require('../views/SecOrganizationLicenseDashboardView');

module.exports = function(organizationId, licenseId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetOrganizationIdentifiers(organizationId), GetOrganizationLicenseDetails(licenseId))
    .done(function(identifiers, license) {
      NavUtils.navigate('#sec/organization/' + organizationId + '/license/' + licenseId + '/dashboard');
      Scaffold.content.show(
        new SecOrganizationLicenseDashboardView({
          viewMode: 'int',
          objectTypeId: 'ORG-LICENSE',
          model: new Backbone.Model({
            organizationId: organizationId,
            licenseId: licenseId,
            identifiers: identifiers,
            license: license
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
